<div class="mx-auto max-w-lg px-2 pb-12 pt-6">
    <div class="flex items-center justify-center">
        <img
            [src]="'assets/images/quotes_new.svg'"
            alt="quotes"
            class="h-6 w-auto" />
    </div>
    <p
        class="mx-auto max-w-sm break-words p-2 text-center font-heading text-xl">
        {{ entry?.body }}
    </p>
</div>
